import { render, staticRenderFns } from "./InvitePage.vue?vue&type=template&id=3ade65c0&scoped=true"
import script from "./InvitePage.vue?vue&type=script&lang=js"
export * from "./InvitePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade65c0",
  null
  
)

export default component.exports